/**
 * Compute the device "user-agent fingerprint" the backend's trust-device flow
 * expects. SHA-256 hex digest of UA + screen + language, exactly 64 chars
 * (the backend's TrustDeviceRequest schema rejects anything else).
 *
 * Stable enough across page reloads on the same device, but changes if the
 * user moves the PWA to a different device or browser — which is what we
 * want, since a trust token from device A shouldn't be honoured if presented
 * from device B.
 */
export async function computeFingerprint() {
  const input = [
    navigator.userAgent,
    `${screen.width}x${screen.height}`,
    navigator.language,
  ].join('|');

  const encoded = new TextEncoder().encode(input);
  const buffer = await crypto.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
